import { useState } from "react";
import { useI18n } from "../i18n/I18nContext";

function NavBar({ collapsed }) {
  const [showMenu, setShowMenu] = useState(false);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const { language, setLanguage, t } = useI18n();
  const languages = [
    { code: "sr", label: "SR", flag: "🇷🇸" },
    { code: "en", label: "EN", flag: "🇬🇧" },
  ];
  const selectedLanguage = languages.find((item) => item.code === language);

  return (
    <>
      <nav className={`navbar ${collapsed ? "collapsed" : ""}`}>
        <div className="left-nav">
          <div
            className="logo-nav-wrapper"
            onClick={() => {
              window.scrollTo(0, 0);
            }}
          >
            <img src="/images/logo.webp" alt={t("alt.logo")} />
          </div>
        </div>
        <div
          className={`nav-collapsed-content ${
            showMenu ? "show-collapsed" : ""
          }`}
        >
          <div className="right-nav">
            <ul
              onClick={() => {
                setShowMenu(false);
              }}
            >
              <li>
                <a href="#landing">{t("nav.home")}</a>
              </li>
              <li
                onClick={() => {
                  // window.location('#meni')

                  var burgerList = document.getElementById("burger-list");

                  window.scrollTo(0, burgerList.offsetTop - 100);
                }}
              >
                {t("nav.burgers")}
              </li>
              <li
                onClick={() => {
                  // window.location('#meni')

                  var meni = document.getElementById("meni");

                  // meni.scrollIntoView()
                  window.scrollTo(0, meni.offsetTop - 100);
                  // window.scrollBy(0, 200)
                }}
              >
                {t("nav.menu")}
              </li>

              <li
                onClick={() => {
                  // window.location('#meni')

                  var meni = document.getElementById("contact-header");

                  // meni.scrollIntoView()
                  window.scrollTo(0, meni.offsetTop - 100);
                  // window.scrollBy(0, 200)
                }}
              >
                {t("nav.contact")}
              </li>
            </ul>
          </div>
          <div
            className="language-switcher"
            onClick={(e) => {
              e.stopPropagation();
            }}
            onBlur={(e) => {
              if (!e.currentTarget.contains(e.relatedTarget)) {
                setShowLanguageMenu(false);
              }
            }}
          >
            <button
              aria-label={t("language.label")}
              aria-expanded={showLanguageMenu}
              aria-haspopup="menu"
              className="language-toggle"
              type="button"
              onClick={() => {
                setShowLanguageMenu((isOpen) => !isOpen);
              }}
            >
              <span>{selectedLanguage.flag}</span>
              <span>{selectedLanguage.label}</span>
              <span
                className={`language-arrow ${
                  showLanguageMenu ? "open" : ""
                }`}
                aria-hidden="true"
              >
                ▾
              </span>
            </button>
            {showLanguageMenu ? (
              <div className="language-options" role="menu">
                {languages.map((item) => {
                  return (
                    <button
                      className={item.code === language ? "selected" : ""}
                      key={item.code}
                      role="menuitem"
                      type="button"
                      onClick={() => {
                        setLanguage(item.code);
                        setShowLanguageMenu(false);
                      }}
                    >
                      <span>{item.flag}</span>
                      <span>{item.label}</span>
                    </button>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
          {/* Poruci dugme, desni deo navigacije */}
          <div className="nav-poruci">
            {/* <button className='btn-classic'>
              <a
                href='https://glovoapp.com/rs/sr/beograd/two-guys-smash-burger-beg/'
                target='_blank'
              >
                Poruči
              </a>{' '}
            </button> */}
            <div className="glovo-wrapper">
              <a
                href="https://wolt.com/sr/srb/belgrade/restaurant/two-guys-smash-burgers"
                rel="noreferrer"
                target={"_blank"}
              >
                {/* <p>Poručite i na Glovu!</p> */}

                <img src="/images/wolt.png" alt={t("alt.wolt")} />
              </a>
            </div>
            <div className="glovo-wrapper">
              <a
                href="https://glovoapp.com/rs/sr/beograd/two-guys-smash-burger-beg/"
                rel="noreferrer"
                target={"_blank"}
              >
                {/* <p>Poručite i na Glovu!</p> */}

                <img src="/images/glovo.webp" alt={t("alt.glovo")} />
              </a>
            </div>
            <div className="glovo-wrapper">
              <a
                href="https://misterd.rs/place/two-guys-smash-burgers-dostava"
                rel="noreferrer"
                target={"_blank"}
              >
                {/* <p>Poručite i na Glovu!</p> */}

                <img src="/images/mrd.webp" alt={t("alt.misterD")} />
              </a>
            </div>
          </div>
        </div>
        <div
          className={`nav-toggle-button`}
          onClick={() =>
            setShowMenu((showMenu) => {
              return !showMenu;
            })
          }
        >
          <img src="/images/menu.webp" alt={t("alt.menu")} />
        </div>
      </nav>
    </>
  );
}

export default NavBar;
